/* eslint-disable local-rules/force-import-custom-makestyles */
import React, { forwardRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { muiPalette } from './muiPalette';
import { SliderThumb } from '@mui/material/Slider';

const ValueLabelComponent = ({ children, open, value }) => {
  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
};

const ThumbComponent = forwardRef((props, ref) => {
  return (
    <SliderThumb
      {...props}
      ref={ref}
      data-qa-id={`thumb-handle-${props['data-index']}`}
    />
  );
});

ThumbComponent.displayName = 'ThumbComponent';

export const sliderWidths = {
  small: 272,
  medium: 352,
  large: 492
};

const DEFAULT_WIDTH = sliderWidths.medium;

export const sliderOverride = {
  props: {
    MuiSlider: {
      defaultProps: {
        slots: {
          valueLabel: ValueLabelComponent,
          thumb: ThumbComponent
        },
        slotProps: {
          input: { 'aria-label': 'thumb-input' }
        },
        valueLabelDisplay: 'auto',
        size: 'small'
      }
    }
  },
  theme: {
    MuiSlider: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          color: ownerState.disabled
            ? muiPalette.palette.grey[300]
            : muiPalette.palette.primary.main,
          width: ownerState.width
            ? sliderWidths[ownerState.width]
            : DEFAULT_WIDTH,
          padding: '13px 4px'
        }),
        track: {
          backgroundColor: 'currentColor',
          height: 4,
          borderRadius: 12
        },
        rail: {
          height: 4,
          opacity: 1,
          backgroundColor: muiPalette.palette.grey[300],
          borderRadius: 12
        },
        thumb: ({ ownerState }) => ({
          backgroundColor: ownerState.disabled
            ? muiPalette.palette.grey[500]
            : 'currentColor',
          width: 14,
          height: 14,
          '&:hover': {
            boxShadow: `0px 0px 0px 4px ${muiPalette.palette.action.hover}`
          },
          '&:focus-visible': {
            boxShadow: `0px 0px 0px 4px ${muiPalette.palette.action.focus}`
          },
          '&.Mui-disabled': {
            width: 14,
            height: 14
          }
        }),
        mark: {
          height: 4,
          width: 4,
          backgroundColor: muiPalette.palette.grey[400],
          borderRadius: 4
        },
        markActive: {
          color: muiPalette.palette.text.primary,
          backgroundColor: 'transparent'
        },
        markLabel: {
          transform: 'translateX(-35%)',
          top: '26px'
        }
      }
    }
  }
};
